const _c0 = ["header"];
const _c1 = ["content"];
const _c2 = ["footer"];
const _c3 = ["closeicon"];
const _c4 = ["maximizeicon"];
const _c5 = ["minimizeicon"];
const _c6 = ["headless"];
const _c7 = ["titlebar"];
const _c8 = ["*", [["p-footer"]]];
const _c9 = ["*", "p-footer"];
const _c10 = a0 => ({
  ariaLabelledBy: a0
});
function Dialog_Conditional_0_Conditional_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._headlessTemplate || ctx_r1.headlessTemplate || ctx_r1.headlessT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("mousedown", function Dialog_Conditional_0_Conditional_1_ng_template_3_div_0_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.initResize($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.cx("resizeHandle"));
    i0.ɵɵstyleProp("z-index", 90);
    i0.ɵɵproperty("pBind", ctx_r1.ptm("resizeHandle"));
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap(ctx_r1.cx("title"));
    i0.ɵɵproperty("id", ctx_r1.ariaLabelledBy)("pBind", ctx_r1.ptm("title"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("ngClass", ctx_r1.maximized ? ctx_r1.minimizeIcon : ctx_r1.maximizeIcon);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_1__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 28);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 29);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_1__svg_svg_1_Template, 1, 0, "svg", 26)(2, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_1__svg_svg_2_Template, 1, 0, "svg", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.maximized && !ctx_r1._maximizeiconTemplate && !ctx_r1.maximizeIconTemplate && !ctx_r1.maximizeIconT);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.maximized && !ctx_r1._minimizeiconTemplate && !ctx_r1.minimizeIconTemplate && !ctx_r1.minimizeIconT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_2_1_ng_template_0_Template(rf, ctx) {}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_2_1_Template, 1, 0, null, 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._maximizeiconTemplate || ctx_r1.maximizeIconTemplate || ctx_r1.maximizeIconT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_3_1_ng_template_0_Template(rf, ctx) {}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_3_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_3_1_Template, 1, 0, null, 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._minimizeiconTemplate || ctx_r1.minimizeIconTemplate || ctx_r1.minimizeIconT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_span_0_Template, 1, 1, "span", 23)(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_1_Template, 3, 2, "ng-container", 24)(2, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_2_Template, 2, 1, "ng-container", 24)(3, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_ng_container_3_Template, 2, 1, "ng-container", 24);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngIf", ctx_r1.maximizeIcon && !ctx_r1._maximizeiconTemplate && !ctx_r1._minimizeiconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.maximizeIcon && !(ctx_r1.maximizeButtonProps == null ? null : ctx_r1.maximizeButtonProps.icon));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.maximized);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.maximized);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 22);
    i0.ɵɵlistener("onClick", function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_Template_p_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.maximize());
    })("keydown.enter", function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_Template_p_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.maximize());
    });
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_ng_template_1_Template, 4, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("pt", ctx_r1.ptm("pcMaximizeButton"))("styleClass", ctx_r1.cx("pcMaximizeButton"))("ariaLabel", ctx_r1.maximized ? ctx_r1.minimizeLabel : ctx_r1.maximizeLabel)("tabindex", ctx_r1.maximizable ? "0" : "-1")("buttonProps", ctx_r1.maximizeButtonProps)("unstyled", ctx_r1.unstyled());
    i0.ɵɵattribute("data-pc-group-section", "headericon");
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_ng_container_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(8);
    i0.ɵɵclassMap(ctx_r1.closeIcon);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_ng_container_0__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 32);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_ng_container_0_span_1_Template, 1, 2, "span", 30)(2, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_ng_container_0__svg_svg_2_Template, 1, 0, "svg", 31);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.closeIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.closeIcon);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_span_1_1_ng_template_0_Template(rf, ctx) {}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_span_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_span_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_span_1_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._closeiconTemplate || ctx_r1.closeIconTemplate || ctx_r1.closeIconT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_ng_container_0_Template, 3, 2, "ng-container", 24)(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_span_1_Template, 2, 1, "span", 24);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngIf", !ctx_r1._closeiconTemplate && !ctx_r1.closeIconTemplate && !ctx_r1.closeIconT && !(ctx_r1.closeButtonProps == null ? null : ctx_r1.closeButtonProps.icon));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._closeiconTemplate || ctx_r1.closeIconTemplate || ctx_r1.closeIconT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 22);
    i0.ɵɵlistener("onClick", function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_Template_p_button_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("keydown.enter", function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_Template_p_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.close($event));
    });
    i0.ɵɵtemplate(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_ng_template_1_Template, 2, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("pt", ctx_r1.ptm("pcCloseButton"))("styleClass", ctx_r1.cx("pcCloseButton"))("ariaLabel", ctx_r1.closeAriaLabel)("tabindex", ctx_r1.closeTabindex)("buttonProps", ctx_r1.closeButtonProps)("unstyled", ctx_r1.unstyled());
    i0.ɵɵattribute("data-pc-group-section", "headericon");
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16, 3);
    i0.ɵɵlistener("mousedown", function Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.initDrag($event));
    });
    i0.ɵɵtemplate(2, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_span_2_Template, 2, 5, "span", 17)(3, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_ng_container_3_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtemplate(5, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_5_Template, 3, 7, "p-button", 20)(6, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_p_button_6_Template, 3, 7, "p-button", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.cx("header"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("header"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1._headerTemplate && !ctx_r1.headerTemplate && !ctx_r1.headerT);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._headerTemplate || ctx_r1.headerTemplate || ctx_r1.headerT)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c10, ctx_r1.ariaLabelledBy));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.cx("headerActions"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("headerActions"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.maximizable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.closable);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19, 5);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵtemplate(3, Dialog_Conditional_0_Conditional_1_ng_template_3_div_6_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.cx("footer"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("footer"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._footerTemplate || ctx_r1.footerTemplate || ctx_r1.footerT);
  }
}
function Dialog_Conditional_0_Conditional_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Dialog_Conditional_0_Conditional_1_ng_template_3_div_0_Template, 1, 5, "div", 12)(1, Dialog_Conditional_0_Conditional_1_ng_template_3_div_1_Template, 7, 13, "div", 13);
    i0.ɵɵelementStart(2, "div", 14, 2);
    i0.ɵɵprojection(4);
    i0.ɵɵtemplate(5, Dialog_Conditional_0_Conditional_1_ng_template_3_ng_container_5_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, Dialog_Conditional_0_Conditional_1_ng_template_3_div_6_Template, 4, 4, "div", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r1.resizable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHeader);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("content"), ctx_r1.contentStyleClass));
    i0.ɵɵproperty("ngStyle", ctx_r1.contentStyle)("pBind", ctx_r1.ptm("content"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1._contentTemplate || ctx_r1.contentTemplate || ctx_r1.contentT);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._footerTemplate || ctx_r1.footerTemplate || ctx_r1.footerT);
  }
}
function Dialog_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9, 0);
    i0.ɵɵlistener("pMotionOnBeforeEnter", function Dialog_Conditional_0_Conditional_1_Template_div_pMotionOnBeforeEnter_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBeforeEnter($event));
    })("pMotionOnAfterEnter", function Dialog_Conditional_0_Conditional_1_Template_div_pMotionOnAfterEnter_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAfterEnter($event));
    })("pMotionOnBeforeLeave", function Dialog_Conditional_0_Conditional_1_Template_div_pMotionOnBeforeLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBeforeLeave($event));
    })("pMotionOnAfterLeave", function Dialog_Conditional_0_Conditional_1_Template_div_pMotionOnAfterLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAfterLeave($event));
    });
    i0.ɵɵtemplate(2, Dialog_Conditional_0_Conditional_1_ng_container_2_Template, 2, 1, "ng-container", 10)(3, Dialog_Conditional_0_Conditional_1_ng_template_3_Template, 7, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notHeadless_r8 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r1.sx("root"));
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("root"), ctx_r1.styleClass));
    i0.ɵɵproperty("ngStyle", ctx_r1.style)("pBind", ctx_r1.ptm("root"))("pFocusTrapDisabled", ctx_r1.focusTrap === false)("pMotion", ctx_r1.visible)("pMotionAppear", true)("pMotionName", "p-dialog")("pMotionOptions", ctx_r1.computedMotionOptions());
    i0.ɵɵattribute("role", ctx_r1.role)("aria-labelledby", ctx_r1.ariaLabelledBy)("aria-modal", true)("data-p", ctx_r1.dataP);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._headlessTemplate || ctx_r1.headlessTemplate || ctx_r1.headlessT)("ngIfElse", notHeadless_r8);
  }
}
function Dialog_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("pMotionOnAfterLeave", function Dialog_Conditional_0_Template_div_pMotionOnAfterLeave_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMaskAfterLeave());
    });
    i0.ɵɵconditionalCreate(1, Dialog_Conditional_0_Conditional_1_Template, 5, 17, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.sx("mask"));
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("mask"), ctx_r1.maskStyleClass));
    i0.ɵɵproperty("ngStyle", ctx_r1.maskStyle)("pBind", ctx_r1.ptm("mask"))("pMotion", ctx_r1.maskVisible)("pMotionAppear", true)("pMotionEnterActiveClass", ctx_r1.modal ? "p-overlay-mask-enter-active" : "")("pMotionLeaveActiveClass", ctx_r1.modal ? "p-overlay-mask-leave-active" : "")("pMotionOptions", ctx_r1.computedMaskMotionOptions());
    i0.ɵɵattribute("data-p-scrollblocker-active", ctx_r1.modal || ctx_r1.blockScroll)("data-p", ctx_r1.dataP);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.renderDialog() ? 1 : -1);
  }
}
export * from 'primeng/types/dialog';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, inject, input, computed, EventEmitter, signal, NgZone, booleanAttribute, numberAttribute, ContentChildren, ContentChild, Input, ViewChild, Output, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { uuid, setAttribute, addStyle, getOuterWidth, getOuterHeight, getViewport, appendChild, removeClass, hasClass } from '@primeuix/utils';
import { TranslationKeys, OverlayService, SharedModule, PrimeTemplate } from 'primeng/api';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i1 from 'primeng/bind';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { DomHandler, blockBodyScroll, unblockBodyScroll } from 'primeng/dom';
import { FocusTrap } from 'primeng/focustrap';
import { TimesIcon, WindowMaximizeIcon, WindowMinimizeIcon } from 'primeng/icons';
import * as i3 from 'primeng/motion';
import { MotionModule } from 'primeng/motion';
import { ZIndexUtils } from 'primeng/utils';
import { style } from '@primeuix/styles/dialog';
import { BaseStyle } from 'primeng/base';

/* Position */
const inlineStyles = {
  mask: ({
    instance
  }) => ({
    position: 'fixed',
    height: '100%',
    width: '100%',
    left: 0,
    top: 0,
    display: 'flex',
    justifyContent: instance.position === 'left' || instance.position === 'topleft' || instance.position === 'bottomleft' ? 'flex-start' : instance.position === 'right' || instance.position === 'topright' || instance.position === 'bottomright' ? 'flex-end' : 'center',
    alignItems: instance.position === 'top' || instance.position === 'topleft' || instance.position === 'topright' ? 'flex-start' : instance.position === 'bottom' || instance.position === 'bottomleft' || instance.position === 'bottomright' ? 'flex-end' : 'center',
    pointerEvents: instance.modal ? 'auto' : 'none'
  }),
  root: {
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto'
  }
};
const classes = {
  mask: ({
    instance
  }) => {
    const positions = ['left', 'right', 'top', 'topleft', 'topright', 'bottom', 'bottomleft', 'bottomright'];
    const pos = positions.find(item => item === instance.position);
    return ['p-dialog-mask', {
      'p-overlay-mask': instance.modal
    }, pos ? `p-dialog-${pos}` : ''];
  },
  root: ({
    instance
  }) => ['p-dialog p-component', {
    'p-dialog-maximized': instance.maximizable && instance.maximized
  }],
  header: 'p-dialog-header',
  title: 'p-dialog-title',
  resizeHandle: 'p-resizable-handle',
  headerActions: 'p-dialog-header-actions',
  pcMaximizeButton: 'p-dialog-maximize-button',
  pcCloseButton: 'p-dialog-close-button',
  content: () => ['p-dialog-content'],
  footer: 'p-dialog-footer'
};
let DialogStyle = /*#__PURE__*/(() => {
  class DialogStyle extends BaseStyle {
    name = 'dialog';
    style = style;
    classes = classes;
    inlineStyles = inlineStyles;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDialogStyle_BaseFactory;
      return function DialogStyle_Factory(__ngFactoryType__) {
        return (ɵDialogStyle_BaseFactory || (ɵDialogStyle_BaseFactory = i0.ɵɵgetInheritedFactory(DialogStyle)))(__ngFactoryType__ || DialogStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DialogStyle,
      factory: DialogStyle.ɵfac
    });
  }
  return DialogStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Dialog is a container to display content in an overlay window.
 *
 * [Live Demo](https://www.primeng.org/dialog)
 *
 * @module dialogstyle
 *
 */
var DialogClasses = /*#__PURE__*/function (DialogClasses) {
  /**
   * Class name of the mask element
   */
  DialogClasses["mask"] = "p-dialog-mask";
  /**
   * Class name of the root element
   */
  DialogClasses["root"] = "p-dialog";
  /**
   * Class name of the header element
   */
  DialogClasses["header"] = "p-dialog-header";
  /**
   * Class name of the title element
   */
  DialogClasses["title"] = "p-dialog-title";
  /**
   * Class name of the header actions element
   */
  DialogClasses["headerActions"] = "p-dialog-header-actions";
  /**
   * Class name of the maximize button element
   */
  DialogClasses["pcMaximizeButton"] = "p-dialog-maximize-button";
  /**
   * Class name of the close button element
   */
  DialogClasses["pcCloseButton"] = "p-dialog-close-button";
  /**
   * Class name of the content element
   */
  DialogClasses["content"] = "p-dialog-content";
  /**
   * Class name of the footer element
   */
  DialogClasses["footer"] = "p-dialog-footer";
  return DialogClasses;
}(DialogClasses || {});
const DIALOG_INSTANCE = /*#__PURE__*/new InjectionToken('DIALOG_INSTANCE');
/**
 * Dialog is a container to display content in an overlay window.
 * @group Components
 */
let Dialog = /*#__PURE__*/(() => {
  class Dialog extends BaseComponent {
    componentName = 'Dialog';
    hostName = '';
    $pcDialog = inject(DIALOG_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptm('host'));
    }
    /**
     * Title text of the dialog.
     * @group Props
     */
    header;
    /**
     * Enables dragging to change the position using header.
     * @group Props
     */
    draggable = true;
    /**
     * Enables resizing of the content.
     * @group Props
     */
    resizable = true;
    /**
     * Style of the content section.
     * @group Props
     */
    contentStyle;
    /**
     * Style class of the content.
     * @group Props
     */
    contentStyleClass;
    /**
     * Defines if background should be blocked when dialog is displayed.
     * @group Props
     */
    modal = false;
    /**
     * Specifies if pressing escape key should hide the dialog.
     * @group Props
     */
    closeOnEscape = true;
    /**
     * Specifies if clicking the modal background should hide the dialog.
     * @group Props
     */
    dismissableMask = false;
    /**
     * When enabled dialog is displayed in RTL direction.
     * @group Props
     */
    rtl = false;
    /**
     * Adds a close icon to the header to hide the dialog.
     * @group Props
     */
    closable = true;
    /**
     * Object literal to define widths per screen size.
     * @group Props
     */
    breakpoints;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Style class of the mask.
     * @group Props
     */
    maskStyleClass;
    /**
     * Style of the mask.
     * @group Props
     */
    maskStyle;
    /**
     * Whether to show the header or not.
     * @group Props
     */
    showHeader = true;
    /**
     * Whether background scroll should be blocked when dialog is visible.
     * @group Props
     */
    blockScroll = false;
    /**
     * Whether to automatically manage layering.
     * @group Props
     */
    autoZIndex = true;
    /**
     * Base zIndex value to use in layering.
     * @group Props
     */
    baseZIndex = 0;
    /**
     * Minimum value for the left coordinate of dialog in dragging.
     * @group Props
     */
    minX = 0;
    /**
     * Minimum value for the top coordinate of dialog in dragging.
     * @group Props
     */
    minY = 0;
    /**
     * When enabled, first focusable element receives focus on show.
     * @group Props
     */
    focusOnShow = true;
    /**
     * Whether the dialog can be displayed full screen.
     * @group Props
     */
    maximizable = false;
    /**
     * Keeps dialog in the viewport.
     * @group Props
     */
    keepInViewport = true;
    /**
     * When enabled, can only focus on elements inside the dialog.
     * @group Props
     */
    focusTrap = true;
    /**
     * Transition options of the animation.
     * @deprecated since v21.0.0. Use `motionOptions` instead.
     * @group Props
     */
    transitionOptions = '150ms cubic-bezier(0, 0, 0.2, 1)';
    /**
     * The motion options for the mask.
     * @group Props
     */
    maskMotionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "maskMotionOptions"
    }] : []));
    computedMaskMotionOptions = computed(() => {
      return {
        ...this.ptm('maskMotion'),
        ...this.maskMotionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMaskMotionOptions"
    }] : []));
    /**
     * The motion options.
     * @group Props
     */
    motionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "motionOptions"
    }] : []));
    computedMotionOptions = computed(() => {
      return {
        ...this.ptm('motion'),
        ...this.motionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMotionOptions"
    }] : []));
    /**
     * Name of the close icon.
     * @group Props
     */
    closeIcon;
    /**
     * Defines a string that labels the close button for accessibility.
     * @group Props
     */
    closeAriaLabel;
    /**
     * Index of the close button in tabbing order.
     * @group Props
     */
    closeTabindex = '0';
    /**
     * Name of the minimize icon.
     * @group Props
     */
    minimizeIcon;
    /**
     * Name of the maximize icon.
     * @group Props
     */
    maximizeIcon;
    /**
     * Used to pass all properties of the ButtonProps to the Button component.
     * @group Props
     */
    closeButtonProps = {
      severity: 'secondary',
      variant: 'text',
      rounded: true
    };
    /**
     * Used to pass all properties of the ButtonProps to the Button component.
     * @group Props
     */
    maximizeButtonProps = {
      severity: 'secondary',
      variant: 'text',
      rounded: true
    };
    /**
     * Specifies the visibility of the dialog.
     * @group Props
     */
    get visible() {
      return this._visible;
    }
    set visible(value) {
      this._visible = value;
      if (this._visible && !this.maskVisible) {
        this.maskVisible = true;
        this.renderMask.set(true);
        this.renderDialog.set(true);
      }
    }
    /**
     * Inline style of the component.
     * @group Props
     */
    get style() {
      return this._style;
    }
    set style(value) {
      if (value) {
        this._style = {
          ...value
        };
        this.originalStyle = value;
      }
    }
    /**
     * Position of the dialog.
     * @group Props
     */
    position;
    /**
     * Role attribute of html element.
     * @group Emits
     */
    role = 'dialog';
    /**
     * Target element to attach the overlay, valid values are "body" or a local ng-template variable of another element (note: use binding with brackets for template variables, e.g. [appendTo]="mydiv" for a div element having #mydiv as variable name).
     * @defaultValue 'self'
     * @group Props
     */
    appendTo = input(undefined, ...(ngDevMode ? [{
      debugName: "appendTo"
    }] : []));
    /**
     * Callback to invoke when dialog is shown.
     * @group Emits
     */
    onShow = new EventEmitter();
    /**
     * Callback to invoke when dialog is hidden.
     * @group Emits
     */
    onHide = new EventEmitter();
    /**
     * This EventEmitter is used to notify changes in the visibility state of a component.
     * @param {boolean} value - New value.
     * @group Emits
     */
    visibleChange = new EventEmitter();
    /**
     * Callback to invoke when dialog resizing is initiated.
     * @param {MouseEvent} event - Mouse event.
     * @group Emits
     */
    onResizeInit = new EventEmitter();
    /**
     * Callback to invoke when dialog resizing is completed.
     * @param {MouseEvent} event - Mouse event.
     * @group Emits
     */
    onResizeEnd = new EventEmitter();
    /**
     * Callback to invoke when dialog dragging is completed.
     * @param {DragEvent} event - Drag event.
     * @group Emits
     */
    onDragEnd = new EventEmitter();
    /**
     * Callback to invoke when dialog maximized or unmaximized.
     * @group Emits
     */
    onMaximize = new EventEmitter();
    headerViewChild;
    contentViewChild;
    footerViewChild;
    /**
     * Header template.
     * @group Templates
     */
    headerTemplate;
    /**
     * Content template.
     * @group Templates
     */
    contentTemplate;
    /**
     * Footer template.
     * @group Templates
     */
    footerTemplate;
    /**
     * Close icon template.
     * @group Templates
     */
    closeIconTemplate;
    /**
     * Maximize icon template.
     * @group Templates
     */
    maximizeIconTemplate;
    /**
     * Minimize icon template.
     * @group Templates
     */
    minimizeIconTemplate;
    /**
     * Headless template.
     * @group Templates
     */
    headlessTemplate;
    /**
     * Custom header template.
     * @group Templates
     */
    _headerTemplate;
    /**
     * Custom content template.
     * @group Templates
     */
    _contentTemplate;
    /**
     * Custom footer template.
     * @group Templates
     */
    _footerTemplate;
    /**
     * Custom close icon template.
     * @group Templates
     */
    _closeiconTemplate;
    /**
     * Custom maximize icon template.
     * @group Templates
     */
    _maximizeiconTemplate;
    /**
     * Custom minimize icon template.
     * @group Templates
     */
    _minimizeiconTemplate;
    /**
     * Custom headless template.
     * @group Templates
     */
    _headlessTemplate;
    $appendTo = computed(() => this.appendTo() || this.config.overlayAppendTo(), ...(ngDevMode ? [{
      debugName: "$appendTo"
    }] : []));
    renderMask = signal(false, ...(ngDevMode ? [{
      debugName: "renderMask"
    }] : []));
    renderDialog = signal(false, ...(ngDevMode ? [{
      debugName: "renderDialog"
    }] : []));
    _visible = false;
    maskVisible;
    container = signal(null, ...(ngDevMode ? [{
      debugName: "container"
    }] : []));
    wrapper;
    dragging;
    ariaLabelledBy = this.getAriaLabelledBy();
    documentDragListener;
    documentDragEndListener;
    resizing;
    documentResizeListener;
    documentResizeEndListener;
    documentEscapeListener;
    maskClickListener;
    lastPageX;
    lastPageY;
    preventVisibleChangePropagation;
    maximized;
    preMaximizeContentHeight;
    preMaximizeContainerWidth;
    preMaximizeContainerHeight;
    preMaximizePageX;
    preMaximizePageY;
    id = uuid('pn_id_');
    _style = {};
    originalStyle;
    transformOptions = 'scale(0.7)';
    styleElement;
    window;
    _componentStyle = inject(DialogStyle);
    headerT;
    contentT;
    footerT;
    closeIconT;
    maximizeIconT;
    minimizeIconT;
    headlessT;
    zIndexForLayering;
    get maximizeLabel() {
      return this.config.getTranslation(TranslationKeys.ARIA)['maximizeLabel'];
    }
    get minimizeLabel() {
      return this.config.getTranslation(TranslationKeys.ARIA)['minimizeLabel'];
    }
    zone = inject(NgZone);
    overlayService = inject(OverlayService);
    get maskClass() {
      const positions = ['left', 'right', 'top', 'topleft', 'topright', 'bottom', 'bottomleft', 'bottomright'];
      const pos = positions.find(item => item === this.position);
      return {
        'p-dialog-mask': true,
        'p-overlay-mask': this.modal || this.dismissableMask,
        [`p-dialog-${pos}`]: pos
      };
    }
    onInit() {
      if (this.breakpoints) {
        this.createStyle();
      }
    }
    templates;
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'header':
            this.headerT = item.template;
            break;
          case 'content':
            this.contentT = item.template;
            break;
          case 'footer':
            this.footerT = item.template;
            break;
          case 'closeicon':
            this.closeIconT = item.template;
            break;
          case 'maximizeicon':
            this.maximizeIconT = item.template;
            break;
          case 'minimizeicon':
            this.minimizeIconT = item.template;
            break;
          case 'headless':
            this.headlessT = item.template;
            break;
          default:
            this.contentT = item.template;
            break;
        }
      });
    }
    getAriaLabelledBy() {
      return this.header !== null ? uuid('pn_id_') + '_header' : null;
    }
    parseDurationToMilliseconds(durationString) {
      const transitionTimeRegex = /([\d\.]+)(ms|s)\b/g;
      let totalMilliseconds = 0;
      let match;
      while ((match = transitionTimeRegex.exec(durationString)) !== null) {
        const value = parseFloat(match[1]);
        const unit = match[2];
        if (unit === 'ms') {
          totalMilliseconds += value;
        } else if (unit === 's') {
          totalMilliseconds += value * 1000;
        }
      }
      if (totalMilliseconds === 0) {
        return undefined;
      }
      return totalMilliseconds;
    }
    _focus(focusParentElement) {
      if (focusParentElement) {
        const timeoutDuration = this.parseDurationToMilliseconds(this.transitionOptions);
        let _focusableElements = DomHandler.getFocusableElements(focusParentElement);
        if (_focusableElements && _focusableElements.length > 0) {
          this.zone.runOutsideAngular(() => {
            setTimeout(() => _focusableElements[0].focus(), timeoutDuration || 5);
          });
          return true;
        }
      }
      return false;
    }
    focus(focusParentElement = this.contentViewChild?.nativeElement) {
      let focused = this._focus(focusParentElement);
      if (!focused) {
        focused = this._focus(this.footerViewChild?.nativeElement);
        if (!focused) {
          focused = this._focus(this.headerViewChild?.nativeElement);
          if (!focused) {
            this._focus(this.contentViewChild?.nativeElement);
          }
        }
      }
    }
    close(event) {
      this.visible = false;
      this.visibleChange.emit(this.visible);
      event.preventDefault();
    }
    enableModality() {
      if (this.closable && this.dismissableMask) {
        this.maskClickListener = this.renderer.listen(this.wrapper, 'mousedown', event => {
          if (this.wrapper && this.wrapper.isSameNode(event.target)) {
            this.close(event);
          }
        });
      }
      if (this.modal) {
        blockBodyScroll();
      }
    }
    disableModality() {
      if (this.wrapper) {
        if (this.dismissableMask) {
          this.unbindMaskClickListener();
        }
        // for nested dialogs w/modal
        const scrollBlockers = document.querySelectorAll('[data-p-scrollblocker-active="true"]');
        if (this.modal && scrollBlockers && scrollBlockers.length == 1) {
          unblockBodyScroll();
        }
        if (!this.cd.destroyed) {
          this.cd.detectChanges();
        }
      }
    }
    maximize() {
      this.maximized = !this.maximized;
      if (!this.modal && !this.blockScroll) {
        if (this.maximized) {
          blockBodyScroll();
        } else {
          unblockBodyScroll();
        }
      }
      this.onMaximize.emit({
        maximized: this.maximized
      });
    }
    unbindMaskClickListener() {
      if (this.maskClickListener) {
        this.maskClickListener();
        this.maskClickListener = null;
      }
    }
    moveOnTop() {
      if (this.autoZIndex) {
        ZIndexUtils.set('modal', this.container(), this.baseZIndex + this.config.zIndex.modal);
        this.wrapper.style.zIndex = String(parseInt(this.container().style.zIndex, 10) - 1);
      } else {
        this.zIndexForLayering = ZIndexUtils.generateZIndex('modal', (this.baseZIndex ?? 0) + this.config.zIndex.modal);
      }
    }
    createStyle() {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.styleElement && !this.$unstyled()) {
          this.styleElement = this.renderer.createElement('style');
          this.styleElement.type = 'text/css';
          setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
          this.renderer.appendChild(this.document.head, this.styleElement);
          let innerHTML = '';
          for (let breakpoint in this.breakpoints) {
            innerHTML += `
                        @media screen and (max-width: ${breakpoint}) {
                            .p-dialog[${this.id}]:not(.p-dialog-maximized) {
                                width: ${this.breakpoints[breakpoint]} !important;
                            }
                        }
                    `;
          }
          this.renderer.setProperty(this.styleElement, 'innerHTML', innerHTML);
          setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
        }
      }
    }
    initDrag(event) {
      const target = event.target;
      const closestDiv = target.closest('div');
      if (closestDiv?.getAttribute('data-pc-section') === 'headeractions') {
        return;
      }
      if (this.draggable) {
        this.dragging = true;
        this.lastPageX = event.pageX;
        this.lastPageY = event.pageY;
        this.container().style.margin = '0';
        this.document.body.setAttribute('data-p-unselectable-text', 'true');
        !this.$unstyled() && addStyle(this.document.body, {
          'user-select': 'none'
        });
      }
    }
    onDrag(event) {
      if (this.dragging && this.container()) {
        const containerWidth = getOuterWidth(this.container());
        const containerHeight = getOuterHeight(this.container());
        const deltaX = event.pageX - this.lastPageX;
        const deltaY = event.pageY - this.lastPageY;
        const offset = this.container().getBoundingClientRect();
        const containerComputedStyle = getComputedStyle(this.container());
        const leftMargin = parseFloat(containerComputedStyle.marginLeft);
        const topMargin = parseFloat(containerComputedStyle.marginTop);
        const leftPos = offset.left + deltaX - leftMargin;
        const topPos = offset.top + deltaY - topMargin;
        const viewport = getViewport();
        this.container().style.position = 'fixed';
        if (this.keepInViewport) {
          if (leftPos >= this.minX && leftPos + containerWidth < viewport.width) {
            this._style.left = `${leftPos}px`;
            this.lastPageX = event.pageX;
            this.container().style.left = `${leftPos}px`;
          }
          if (topPos >= this.minY && topPos + containerHeight < viewport.height) {
            this._style.top = `${topPos}px`;
            this.lastPageY = event.pageY;
            this.container().style.top = `${topPos}px`;
          }
        } else {
          this.lastPageX = event.pageX;
          this.container().style.left = `${leftPos}px`;
          this.lastPageY = event.pageY;
          this.container().style.top = `${topPos}px`;
        }
        this.overlayService.emitParentDrag(this.container());
      }
    }
    endDrag(event) {
      if (this.dragging) {
        this.dragging = false;
        this.document.body.removeAttribute('data-p-unselectable-text');
        !this.$unstyled() && (this.document.body.style['user-select'] = '');
        this.cd.detectChanges();
        this.onDragEnd.emit(event);
      }
    }
    resetPosition() {
      this.container().style.position = '';
      this.container().style.left = '';
      this.container().style.top = '';
      this.container().style.margin = '';
    }
    //backward compatibility
    center() {
      this.resetPosition();
    }
    initResize(event) {
      if (this.resizable) {
        this.resizing = true;
        this.lastPageX = event.pageX;
        this.lastPageY = event.pageY;
        this.document.body.setAttribute('data-p-unselectable-text', 'true');
        !this.$unstyled() && addStyle(this.document.body, {
          'user-select': 'none'
        });
        this.onResizeInit.emit(event);
      }
    }
    onResize(event) {
      if (this.resizing) {
        let deltaX = event.pageX - this.lastPageX;
        let deltaY = event.pageY - this.lastPageY;
        let containerWidth = getOuterWidth(this.container());
        let containerHeight = getOuterHeight(this.container());
        let contentHeight = getOuterHeight(this.contentViewChild?.nativeElement);
        let newWidth = containerWidth + deltaX;
        let newHeight = containerHeight + deltaY;
        let minWidth = this.container().style.minWidth;
        let minHeight = this.container().style.minHeight;
        let offset = this.container().getBoundingClientRect();
        let viewport = getViewport();
        let hasBeenDragged = !parseInt(this.container().style.top) || !parseInt(this.container().style.left);
        if (hasBeenDragged) {
          newWidth += deltaX;
          newHeight += deltaY;
        }
        if ((!minWidth || newWidth > parseInt(minWidth)) && offset.left + newWidth < viewport.width) {
          this._style.width = newWidth + 'px';
          this.container().style.width = this._style.width;
        }
        if ((!minHeight || newHeight > parseInt(minHeight)) && offset.top + newHeight < viewport.height) {
          this.contentViewChild.nativeElement.style.height = contentHeight + newHeight - containerHeight + 'px';
          if (this._style.height) {
            this._style.height = newHeight + 'px';
            this.container().style.height = this._style.height;
          }
        }
        this.lastPageX = event.pageX;
        this.lastPageY = event.pageY;
      }
    }
    resizeEnd(event) {
      if (this.resizing) {
        this.resizing = false;
        this.document.body.removeAttribute('data-p-unselectable-text');
        !this.$unstyled() && (this.document.body.style['user-select'] = '');
        this.onResizeEnd.emit(event);
      }
    }
    bindGlobalListeners() {
      if (this.draggable) {
        this.bindDocumentDragListener();
        this.bindDocumentDragEndListener();
      }
      if (this.resizable) {
        this.bindDocumentResizeListeners();
      }
      if (this.closeOnEscape && this.closable) {
        this.bindDocumentEscapeListener();
      }
    }
    unbindGlobalListeners() {
      this.unbindDocumentDragListener();
      this.unbindDocumentDragEndListener();
      this.unbindDocumentResizeListeners();
      this.unbindDocumentEscapeListener();
    }
    bindDocumentDragListener() {
      if (!this.documentDragListener) {
        this.zone.runOutsideAngular(() => {
          this.documentDragListener = this.renderer.listen(this.document.defaultView, 'mousemove', this.onDrag.bind(this));
        });
      }
    }
    unbindDocumentDragListener() {
      if (this.documentDragListener) {
        this.documentDragListener();
        this.documentDragListener = null;
      }
    }
    bindDocumentDragEndListener() {
      if (!this.documentDragEndListener) {
        this.zone.runOutsideAngular(() => {
          this.documentDragEndListener = this.renderer.listen(this.document.defaultView, 'mouseup', this.endDrag.bind(this));
        });
      }
    }
    unbindDocumentDragEndListener() {
      if (this.documentDragEndListener) {
        this.documentDragEndListener();
        this.documentDragEndListener = null;
      }
    }
    bindDocumentResizeListeners() {
      if (!this.documentResizeListener && !this.documentResizeEndListener) {
        this.zone.runOutsideAngular(() => {
          this.documentResizeListener = this.renderer.listen(this.document.defaultView, 'mousemove', this.onResize.bind(this));
          this.documentResizeEndListener = this.renderer.listen(this.document.defaultView, 'mouseup', this.resizeEnd.bind(this));
        });
      }
    }
    unbindDocumentResizeListeners() {
      if (this.documentResizeListener && this.documentResizeEndListener) {
        this.documentResizeListener();
        this.documentResizeEndListener();
        this.documentResizeListener = null;
        this.documentResizeEndListener = null;
      }
    }
    bindDocumentEscapeListener() {
      const documentTarget = this.el ? this.el.nativeElement.ownerDocument : 'document';
      this.documentEscapeListener = this.renderer.listen(documentTarget, 'keydown', event => {
        if (event.key == 'Escape') {
          const container = this.container();
          if (!container) {
            return;
          }
          const currentZIndex = ZIndexUtils.getCurrent();
          if (parseInt(container.style.zIndex) == currentZIndex || this.zIndexForLayering == currentZIndex) {
            this.close(event);
          }
        }
      });
    }
    unbindDocumentEscapeListener() {
      if (this.documentEscapeListener) {
        this.documentEscapeListener();
        this.documentEscapeListener = null;
      }
    }
    appendContainer() {
      if (this.$appendTo() !== 'self') {
        appendChild(this.document.body, this.wrapper);
      }
    }
    restoreAppend() {
      if (this.container() && this.$appendTo() !== 'self') {
        this.renderer.appendChild(this.el.nativeElement, this.wrapper);
      }
    }
    onBeforeEnter(event) {
      this.container.set(event.element);
      this.wrapper = this.container()?.parentElement;
      this.$attrSelector && this.container()?.setAttribute(this.$attrSelector, '');
      this.appendContainer();
      this.moveOnTop();
      this.bindGlobalListeners();
      this.container()?.setAttribute(this.id, '');
      if (this.modal) {
        this.enableModality();
      }
    }
    onAfterEnter() {
      if (this.focusOnShow) {
        this.focus();
      }
      this.onShow.emit({});
    }
    onBeforeLeave() {
      if (this.modal) {
        this.maskVisible = false;
      }
    }
    onAfterLeave() {
      this.onContainerDestroy();
      this.renderDialog.set(false);
      if (this.modal) {
        this.renderMask.set(false);
      } else {
        this.maskVisible = false;
      }
      this.onHide.emit({});
      this.cd.markForCheck();
    }
    onMaskAfterLeave() {
      if (!this.renderDialog()) {
        this.renderMask.set(false);
      }
    }
    onContainerDestroy() {
      this.unbindGlobalListeners();
      this.dragging = false;
      if (this.maximized) {
        removeClass(this.document.body, 'p-overflow-hidden');
        this.document.body.style.removeProperty('--scrollbar-width');
        this.maximized = false;
      }
      if (this.modal) {
        this.disableModality();
      }
      if (hasClass(this.document.body, 'p-overflow-hidden')) {
        removeClass(this.document.body, 'p-overflow-hidden');
      }
      if (this.container() && this.autoZIndex) {
        ZIndexUtils.clear(this.container());
      }
      if (this.zIndexForLayering) {
        ZIndexUtils.revertZIndex(this.zIndexForLayering);
      }
      this.container.set(null);
      this.wrapper = null;
      this._style = this.originalStyle ? {
        ...this.originalStyle
      } : {};
    }
    destroyStyle() {
      if (this.styleElement) {
        this.renderer.removeChild(this.document.head, this.styleElement);
        this.styleElement = null;
      }
    }
    onDestroy() {
      if (this.container()) {
        this.restoreAppend();
        this.onContainerDestroy();
      }
      this.destroyStyle();
    }
    get dataP() {
      return this.cn({
        maximized: this.maximized,
        modal: this.modal
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDialog_BaseFactory;
      return function Dialog_Factory(__ngFactoryType__) {
        return (ɵDialog_BaseFactory || (ɵDialog_BaseFactory = i0.ɵɵgetInheritedFactory(Dialog)))(__ngFactoryType__ || Dialog);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Dialog,
      selectors: [["p-dialog"]],
      contentQueries: function Dialog_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 4)(dirIndex, _c1, 4)(dirIndex, _c2, 4)(dirIndex, _c3, 4)(dirIndex, _c4, 4)(dirIndex, _c5, 4)(dirIndex, _c6, 4)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._contentTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._footerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._closeiconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._maximizeiconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._minimizeiconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._headlessTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function Dialog_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 5)(_c1, 5)(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerViewChild = _t.first);
        }
      },
      inputs: {
        hostName: "hostName",
        header: "header",
        draggable: [2, "draggable", "draggable", booleanAttribute],
        resizable: [2, "resizable", "resizable", booleanAttribute],
        contentStyle: "contentStyle",
        contentStyleClass: "contentStyleClass",
        modal: [2, "modal", "modal", booleanAttribute],
        closeOnEscape: [2, "closeOnEscape", "closeOnEscape", booleanAttribute],
        dismissableMask: [2, "dismissableMask", "dismissableMask", booleanAttribute],
        rtl: [2, "rtl", "rtl", booleanAttribute],
        closable: [2, "closable", "closable", booleanAttribute],
        breakpoints: "breakpoints",
        styleClass: "styleClass",
        maskStyleClass: "maskStyleClass",
        maskStyle: "maskStyle",
        showHeader: [2, "showHeader", "showHeader", booleanAttribute],
        blockScroll: [2, "blockScroll", "blockScroll", booleanAttribute],
        autoZIndex: [2, "autoZIndex", "autoZIndex", booleanAttribute],
        baseZIndex: [2, "baseZIndex", "baseZIndex", numberAttribute],
        minX: [2, "minX", "minX", numberAttribute],
        minY: [2, "minY", "minY", numberAttribute],
        focusOnShow: [2, "focusOnShow", "focusOnShow", booleanAttribute],
        maximizable: [2, "maximizable", "maximizable", booleanAttribute],
        keepInViewport: [2, "keepInViewport", "keepInViewport", booleanAttribute],
        focusTrap: [2, "focusTrap", "focusTrap", booleanAttribute],
        transitionOptions: "transitionOptions",
        maskMotionOptions: [1, "maskMotionOptions"],
        motionOptions: [1, "motionOptions"],
        closeIcon: "closeIcon",
        closeAriaLabel: "closeAriaLabel",
        closeTabindex: "closeTabindex",
        minimizeIcon: "minimizeIcon",
        maximizeIcon: "maximizeIcon",
        closeButtonProps: "closeButtonProps",
        maximizeButtonProps: "maximizeButtonProps",
        visible: "visible",
        style: "style",
        position: "position",
        role: "role",
        appendTo: [1, "appendTo"],
        headerTemplate: [0, "content", "headerTemplate"],
        contentTemplate: "contentTemplate",
        footerTemplate: "footerTemplate",
        closeIconTemplate: "closeIconTemplate",
        maximizeIconTemplate: "maximizeIconTemplate",
        minimizeIconTemplate: "minimizeIconTemplate",
        headlessTemplate: "headlessTemplate"
      },
      outputs: {
        onShow: "onShow",
        onHide: "onHide",
        visibleChange: "visibleChange",
        onResizeInit: "onResizeInit",
        onResizeEnd: "onResizeEnd",
        onDragEnd: "onDragEnd",
        onMaximize: "onMaximize"
      },
      features: [i0.ɵɵProvidersFeature([DialogStyle, {
        provide: DIALOG_INSTANCE,
        useExisting: Dialog
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Dialog
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c9,
      decls: 1,
      vars: 1,
      consts: [["container", ""], ["notHeadless", ""], ["content", ""], ["titlebar", ""], ["icon", ""], ["footer", ""], [3, "class", "style", "ngStyle", "pBind", "pMotion", "pMotionAppear", "pMotionEnterActiveClass", "pMotionLeaveActiveClass", "pMotionOptions"], [3, "pMotionOnAfterLeave", "ngStyle", "pBind", "pMotion", "pMotionAppear", "pMotionEnterActiveClass", "pMotionLeaveActiveClass", "pMotionOptions"], ["pFocusTrap", "", 3, "class", "style", "ngStyle", "pBind", "pFocusTrapDisabled", "pMotion", "pMotionAppear", "pMotionName", "pMotionOptions"], ["pFocusTrap", "", 3, "pMotionOnBeforeEnter", "pMotionOnAfterEnter", "pMotionOnBeforeLeave", "pMotionOnAfterLeave", "ngStyle", "pBind", "pFocusTrapDisabled", "pMotion", "pMotionAppear", "pMotionName", "pMotionOptions"], [4, "ngIf", "ngIfElse"], [4, "ngTemplateOutlet"], [3, "class", "pBind", "z-index", "mousedown", 4, "ngIf"], [3, "class", "pBind", "mousedown", 4, "ngIf"], [3, "ngStyle", "pBind"], [3, "class", "pBind", 4, "ngIf"], [3, "mousedown", "pBind"], [3, "id", "class", "pBind", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "pBind"], [3, "pt", "styleClass", "ariaLabel", "tabindex", "buttonProps", "unstyled", "onClick", "keydown.enter", 4, "ngIf"], [3, "id", "pBind"], [3, "onClick", "keydown.enter", "pt", "styleClass", "ariaLabel", "tabindex", "buttonProps", "unstyled"], [3, "ngClass", 4, "ngIf"], [4, "ngIf"], [3, "ngClass"], ["data-p-icon", "window-maximize", 4, "ngIf"], ["data-p-icon", "window-minimize", 4, "ngIf"], ["data-p-icon", "window-maximize"], ["data-p-icon", "window-minimize"], [3, "class", 4, "ngIf"], ["data-p-icon", "times", 4, "ngIf"], ["data-p-icon", "times"]],
      template: function Dialog_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c8);
          i0.ɵɵconditionalCreate(0, Dialog_Conditional_0_Template, 2, 14, "div", 6);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.renderMask() ? 0 : -1);
        }
      },
      dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, Button, FocusTrap, TimesIcon, WindowMaximizeIcon, WindowMinimizeIcon, SharedModule, Bind, MotionModule, i3.MotionDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Dialog;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogModule = /*#__PURE__*/(() => {
  class DialogModule {
    static ɵfac = function DialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DialogModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DialogModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Dialog, SharedModule, SharedModule]
    });
  }
  return DialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Dialog, DialogClasses, DialogModule, DialogStyle };
